/**
 * The value a design token computes to on the root element, for SVG presentation attributes,
 * where `var()` does not resolve. Call it during render, never at module scope: in dev the
 * stylesheets are injected after the module graph evaluates.
 */
export function readToken(name: string, fallback: string): string {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}
